<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Labels') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Project labels allow you to organize and categorize tasks within your project. Labels are shared with all project members and help create a consistent categorization system across the team.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|You can create custom labels for your project and apply them to tasks. Labels can be used to filter tasks, group related work, or mark tasks with specific attributes like priority, type, or status.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Project Labels vs Personal Labels') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Project labels are visible to all project members and are used for team-wide organization. Personal labels (configured in your profile) are private to you and can be used across all your projects for your own organization system.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Use Cases') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Categorize tasks by type (Bug, Feature, Enhancement)') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Mark tasks by priority or urgency') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Group tasks by component or area') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Filter and search tasks more effectively') }}
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
